import { useEffect, useState } from 'react';

export function useCountdown(seconds: number, onComplete?: () => void): number {
  const [count, setCount] = useState(seconds);

  useEffect(() => {
    let remaining = seconds;

    const interval = setInterval(() => {
      remaining -= 1;
      setCount(remaining);

      if (remaining <= 0) {
        clearInterval(interval);
        onComplete?.();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, onComplete]);

  return count;
}
